import { toast } from "@/components/toast/toast-queue";

type TOAST_TYPE = "error" | "success" | "warning";

export enum ToastTypeEnum {
  ERROR = "error",
  SUCCESS = "success",
  WARNING = "warning",
}

export function showToast(message: string, type: TOAST_TYPE): void {
  toast.add(
    {
      title: message,
      type,
    },
    {
      timeout: 5000,
    },
  );
}
